import PropTypes from 'prop-types'
import { Box } from '@rebass/grid'
import styled from 'style'

const Container = styled(Box)`
  max-width: ${props => props.maxWidth};
`

Container.propTypes = {
  maxWidth: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
}

Container.defaultProps = {
  mx: '1 rem auto',
  position: 'relative',
  maxWidth: '1920px',
  margin: '1rem auto',
  textAlign: 'center',
  marginTop: '2.25rem',
  fontFamily: '-apple-system,BlinkMacSystemFont,"Helvetica Neue","Segoe UI","Roboto","Arial","Noto Sans",sans-serif,' +
      '"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
  font: 'Helvetica Neue',
  fontSize: '200%',

}

export default Container
